module.exports = __webpack_public_path__ + "img/pay.36d080b2.png";